export default "__VITE_ASSET__7jlqM3oeOeY$T94puST3wQ__"